<mat-button-toggle
  class="toolbar-button"
  (click)="toggleShowRoute()"
  [checked]="settingsStore('showRoute').$ | async"
  matTooltip="Toggle Route"
>
  <mat-icon [h3CustomIcon]="toggleRouteIcon"></mat-icon>
</mat-button-toggle>
<mat-button-toggle
  class="toolbar-button"
  (click)="toggleOrthographicCamera()"
  [checked]="settingsStore('useOrthographicCamera').$ | async"
  [matTooltip]="toggleOrthographicCameraTooltip"
>
  <mat-icon [h3CustomIcon]="topViewIcon"></mat-icon>
</mat-button-toggle>
<mat-button-toggle
  class="toolbar-button"
  (click)="toggleHideGround()"
  [checked]="settingsStore('hideGround').$ | async"
  matTooltip="Toggle ground"
>
  <mat-icon [h3CustomIcon]="toggleGroundIcon"></mat-icon>
</mat-button-toggle>
